export default {
  'pet-recommendations:page-title': 'Tailored for your four-legged friend',
  'pet-recommendations:cdp:title:dog': 'Recommendations for your dog',
};
